import { api } from './api';
import type { Testimonial, CreateTestimonialInput, UpdateTestimonialInput } from '../types/entities';

export const testimonialsService = {
  getAll: async (): Promise<Testimonial[]> => {
    const response = await api.get<Testimonial[]>('/api/admin/testimonials');
    return response.data;
  },

  getById: async (id: string): Promise<Testimonial> => {
    const response = await api.get<Testimonial>(`/api/admin/testimonials/${id}`);
    return response.data;
  },

  create: async (data: CreateTestimonialInput): Promise<Testimonial> => {
    const response = await api.post<Testimonial>('/api/admin/testimonials', data);
    return response.data;
  },

  update: async (id: string, data: UpdateTestimonialInput): Promise<Testimonial> => {
    const response = await api.put<Testimonial>(`/api/admin/testimonials/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/api/admin/testimonials/${id}`);
  },
};
